'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const EntityDictionary=require('pulsar-utils/dist-es6/domain/entityDictionary');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');let

FleetHistogramDirective=class FleetHistogramDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/features/fleetInsight/components/fatigueTrends/fleetHistogramView';
}

get objectBindings(){
return['group'];
}

get controller(){
return FleetHistogramController;
}};let


FleetHistogramController=class FleetHistogramController extends BaseController{
static get $inject(){
return['uncaughtErrorHandler'];
}

constructor(uncaughtErrorHandler){
super(uncaughtErrorHandler);
}};


module.exports=FleetHistogramDirective;
//# sourceMappingURL=fleetHistogramDirective.js.map
